import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocalAtm = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M26.667 5.333h-21.333c-1.48 0-2.653 1.187-2.653 2.667l-0.013 16c0 1.48 1.187 2.667 2.667 2.667h21.333c1.48 0 2.667-1.187 2.667-2.667v-16c0-1.48-1.187-2.667-2.667-2.667zM26.667 22.667c0 0.733-0.6 1.333-1.333 1.333h-18.667c-0.733 0-1.333-0.6-1.333-1.333v-13.333c0-0.733 0.6-1.333 1.333-1.333h18.667c0.733 0 1.333 0.6 1.333 1.333v13.333zM18.667 13.333c0.733 0 1.333-0.6 1.333-1.333s-0.6-1.333-1.333-1.333h-1.333v-0.013c0-0.733-0.6-1.333-1.333-1.333s-1.333 0.6-1.333 1.333v0.013h-1.333c-0.733 0-1.333 0.6-1.333 1.333v4c0 0.733 0.6 1.333 1.333 1.333h4v1.333h-4c-0.733 0-1.333 0.6-1.333 1.333s0.6 1.333 1.333 1.333h1.333c0 0.733 0.6 1.333 1.333 1.333s1.333-0.6 1.333-1.333h1.333c0.733 0 1.333-0.6 1.333-1.333v-4c0-0.733-0.6-1.333-1.333-1.333h-4v-1.333h4z" })
});
export default SvgLocalAtm;
